"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styles_1 = require("./styles");

var flexStyles = require("@headspace/hs-web-style-guide/dist/flex");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var close = require("../../../icons/closeDoveGrey.svg");

var _a = flexStyles.default,
    flex = _a.flex,
    alignItemsCenter = _a.alignItemsCenter,
    justifyContentSpaceBetween = _a.justifyContentSpaceBetween;

exports.ListInput = function (_a) {
  var onChange = _a.onChange,
      onBlur = _a.onBlur,
      onClick = _a.onClick,
      addItem = _a.addItem,
      deleteItem = _a.deleteItem,
      id = _a.id,
      open = _a.open,
      coverValue = _a.coverValue,
      placeholder = _a.placeholder,
      value = _a.value,
      addItemText = _a.addItemText,
      hasError = _a.hasError,
      disabled = _a.disabled,
      customInputStyles = _a.customInputStyles,
      list = _a.list;
  return React.createElement("div", __assign({}, styles_1.width100Style), React.createElement("div", __assign({
    onClick: onClick
  }, styles_1.inputStyles(hasError), styles_1.selectStyles(hasError), {
    className: open ? 'open' : ''
  }), coverValue), open && React.createElement("div", __assign({}, styles_1.dropdownDrawerStyles), React.createElement("input", __assign({
    onChange: onChange,
    id: id,
    value: value,
    placeholder: placeholder
  }, font_1.p4, styles_1.inputStyles(hasError), styles_1.selectInputStyles(), styles_1.inputOptions(customInputStyles))), React.createElement("label", __assign({
    htmlFor: id
  }, font_1.labelBoldM, styles_1.selectInputLabelStyles, {
    onClick: disabled ? function () {} : addItem
  }), addItemText), list.map(function (listItem, i) {
    return React.createElement("div", __assign({}, flex, alignItemsCenter, justifyContentSpaceBetween, styles_1.listItemCardStyles, {
      key: listItem
    }), React.createElement("div", null, "@", listItem), React.createElement("div", __assign({}, styles_1.listItemIconStyles(close), {
      id: i.toString(),
      onClick: deleteItem
    })));
  })));
};